import ConsortiumPageResponseResource from "common/resources/Consortium/ConsortiumPageResponseResource";
import ConsortiumRegistrationRequestResource from "common/resources/Consortium/ConsortiumRegistrationRequestResource";
import { singleton } from "tsyringe";

import BaseApi from "./BaseApi";

export type ConsortiumRegistrationFiles = {
	orias?: File;
	rcp?: File;
};

@singleton()
export default class ConsortiumApi extends BaseApi {
	private readonly baseUrl = `${this.apiUrl}/consortium`;

	public async getPage() {
		return this.getRequest<ConsortiumPageResponseResource>(this.baseUrl);
	}

	public async subscribe(request: ConsortiumRegistrationRequestResource, files: ConsortiumRegistrationFiles) {
		const formData = new FormData();
		formData.append("mobile", request.mobile);
		if (files.orias) formData.append("orias", files.orias);
		if (files.rcp) formData.append("rcp", files.rcp);

		return this.postRequestFormdata<ConsortiumPageResponseResource>(this.baseUrl, formData);
	}

	public async refresh() {
		return this.postRequest<ConsortiumPageResponseResource>(`${this.baseUrl}/refresh`);
	}
}
